// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none,json_types=true"
// @generated from file guardianai/v1/admin/blog.proto (package guardianai.v1.admin, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { EmptySchema, Timestamp, TimestampJson } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_empty, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file guardianai/v1/admin/blog.proto.
 */
export const file_guardianai_v1_admin_blog: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp, file_google_protobuf_empty]);

/**
 * @generated from message guardianai.v1.admin.Blog
 */
export type Blog = Message<"guardianai.v1.admin.Blog"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string slug = 2;
   */
  slug: string;

  /**
   * @generated from field: string title = 3;
   */
  title: string;

  /**
   * @generated from field: string content = 4;
   */
  content: string;

  /**
   * @generated from field: string author = 5;
   */
  author: string;

  /**
   * @generated from field: optional string youtube_video_id = 6;
   */
  youtubeVideoId?: string;

  /**
   * @generated from field: optional string seo_description = 7;
   */
  seoDescription?: string;

  /**
   * @generated from field: optional string seo_keywords = 8;
   */
  seoKeywords?: string;

  /**
   * @generated from field: optional string og_image_url = 9;
   */
  ogImageUrl?: string;

  /**
   * @generated from field: string status = 10;
   */
  status: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp published_at = 11;
   */
  publishedAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 12;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 13;
   */
  updatedAt?: Timestamp;
};

/**
 * @generated from message guardianai.v1.admin.Blog
 */
export type BlogJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;

  /**
   * @generated from field: string slug = 2;
   */
  slug?: string;

  /**
   * @generated from field: string title = 3;
   */
  title?: string;

  /**
   * @generated from field: string content = 4;
   */
  content?: string;

  /**
   * @generated from field: string author = 5;
   */
  author?: string;

  /**
   * @generated from field: optional string youtube_video_id = 6;
   */
  youtubeVideoId?: string;

  /**
   * @generated from field: optional string seo_description = 7;
   */
  seoDescription?: string;

  /**
   * @generated from field: optional string seo_keywords = 8;
   */
  seoKeywords?: string;

  /**
   * @generated from field: optional string og_image_url = 9;
   */
  ogImageUrl?: string;

  /**
   * @generated from field: string status = 10;
   */
  status?: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp published_at = 11;
   */
  publishedAt?: TimestampJson;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 12;
   */
  createdAt?: TimestampJson;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 13;
   */
  updatedAt?: TimestampJson;
};

/**
 * Describes the message guardianai.v1.admin.Blog.
 * Use `create(BlogSchema)` to create a new message.
 */
export const BlogSchema: GenMessage<Blog, {jsonType: BlogJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_blog, 0);

/**
 * @generated from message guardianai.v1.admin.ListBlogsRequest
 */
export type ListBlogsRequest = Message<"guardianai.v1.admin.ListBlogsRequest"> & {
  /**
   * @generated from field: int32 page = 1;
   */
  page: number;

  /**
   * @generated from field: int32 limit = 2;
   */
  limit: number;
};

/**
 * @generated from message guardianai.v1.admin.ListBlogsRequest
 */
export type ListBlogsRequestJson = {
  /**
   * @generated from field: int32 page = 1;
   */
  page?: number;

  /**
   * @generated from field: int32 limit = 2;
   */
  limit?: number;
};

/**
 * Describes the message guardianai.v1.admin.ListBlogsRequest.
 * Use `create(ListBlogsRequestSchema)` to create a new message.
 */
export const ListBlogsRequestSchema: GenMessage<ListBlogsRequest, {jsonType: ListBlogsRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_blog, 1);

/**
 * @generated from message guardianai.v1.admin.ListBlogsResponse
 */
export type ListBlogsResponse = Message<"guardianai.v1.admin.ListBlogsResponse"> & {
  /**
   * @generated from field: repeated guardianai.v1.admin.Blog blogs = 1;
   */
  blogs: Blog[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount: number;
};

/**
 * @generated from message guardianai.v1.admin.ListBlogsResponse
 */
export type ListBlogsResponseJson = {
  /**
   * @generated from field: repeated guardianai.v1.admin.Blog blogs = 1;
   */
  blogs?: BlogJson[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount?: number;
};

/**
 * Describes the message guardianai.v1.admin.ListBlogsResponse.
 * Use `create(ListBlogsResponseSchema)` to create a new message.
 */
export const ListBlogsResponseSchema: GenMessage<ListBlogsResponse, {jsonType: ListBlogsResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_blog, 2);

/**
 * @generated from message guardianai.v1.admin.CreateBlogRequest
 */
export type CreateBlogRequest = Message<"guardianai.v1.admin.CreateBlogRequest"> & {
  /**
   * @generated from field: string slug = 1;
   */
  slug: string;

  /**
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * @generated from field: string content = 3;
   */
  content: string;

  /**
   * @generated from field: string author = 4;
   */
  author: string;

  /**
   * @generated from field: optional string youtube_video_id = 5;
   */
  youtubeVideoId?: string;

  /**
   * @generated from field: optional string seo_description = 6;
   */
  seoDescription?: string;

  /**
   * @generated from field: optional string seo_keywords = 7;
   */
  seoKeywords?: string;

  /**
   * @generated from field: optional string og_image_url = 8;
   */
  ogImageUrl?: string;

  /**
   * @generated from field: string status = 9;
   */
  status: string;
};

/**
 * @generated from message guardianai.v1.admin.CreateBlogRequest
 */
export type CreateBlogRequestJson = {
  /**
   * @generated from field: string slug = 1;
   */
  slug?: string;

  /**
   * @generated from field: string title = 2;
   */
  title?: string;

  /**
   * @generated from field: string content = 3;
   */
  content?: string;

  /**
   * @generated from field: string author = 4;
   */
  author?: string;

  /**
   * @generated from field: optional string youtube_video_id = 5;
   */
  youtubeVideoId?: string;

  /**
   * @generated from field: optional string seo_description = 6;
   */
  seoDescription?: string;

  /**
   * @generated from field: optional string seo_keywords = 7;
   */
  seoKeywords?: string;

  /**
   * @generated from field: optional string og_image_url = 8;
   */
  ogImageUrl?: string;

  /**
   * @generated from field: string status = 9;
   */
  status?: string;
};

/**
 * Describes the message guardianai.v1.admin.CreateBlogRequest.
 * Use `create(CreateBlogRequestSchema)` to create a new message.
 */
export const CreateBlogRequestSchema: GenMessage<CreateBlogRequest, {jsonType: CreateBlogRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_blog, 3);

/**
 * @generated from message guardianai.v1.admin.UpdateBlogRequest
 */
export type UpdateBlogRequest = Message<"guardianai.v1.admin.UpdateBlogRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: optional string slug = 2;
   */
  slug?: string;

  /**
   * @generated from field: optional string title = 3;
   */
  title?: string;

  /**
   * @generated from field: optional string content = 4;
   */
  content?: string;

  /**
   * @generated from field: optional string author = 5;
   */
  author?: string;

  /**
   * @generated from field: optional string youtube_video_id = 6;
   */
  youtubeVideoId?: string;

  /**
   * @generated from field: optional string seo_description = 7;
   */
  seoDescription?: string;

  /**
   * @generated from field: optional string seo_keywords = 8;
   */
  seoKeywords?: string;

  /**
   * @generated from field: optional string og_image_url = 9;
   */
  ogImageUrl?: string;

  /**
   * @generated from field: optional string status = 10;
   */
  status?: string;
};

/**
 * @generated from message guardianai.v1.admin.UpdateBlogRequest
 */
export type UpdateBlogRequestJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;

  /**
   * @generated from field: optional string slug = 2;
   */
  slug?: string;

  /**
   * @generated from field: optional string title = 3;
   */
  title?: string;

  /**
   * @generated from field: optional string content = 4;
   */
  content?: string;

  /**
   * @generated from field: optional string author = 5;
   */
  author?: string;

  /**
   * @generated from field: optional string youtube_video_id = 6;
   */
  youtubeVideoId?: string;

  /**
   * @generated from field: optional string seo_description = 7;
   */
  seoDescription?: string;

  /**
   * @generated from field: optional string seo_keywords = 8;
   */
  seoKeywords?: string;

  /**
   * @generated from field: optional string og_image_url = 9;
   */
  ogImageUrl?: string;

  /**
   * @generated from field: optional string status = 10;
   */
  status?: string;
};

/**
 * Describes the message guardianai.v1.admin.UpdateBlogRequest.
 * Use `create(UpdateBlogRequestSchema)` to create a new message.
 */
export const UpdateBlogRequestSchema: GenMessage<UpdateBlogRequest, {jsonType: UpdateBlogRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_blog, 4);

/**
 * @generated from message guardianai.v1.admin.DeleteBlogRequest
 */
export type DeleteBlogRequest = Message<"guardianai.v1.admin.DeleteBlogRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * @generated from message guardianai.v1.admin.DeleteBlogRequest
 */
export type DeleteBlogRequestJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;
};

/**
 * Describes the message guardianai.v1.admin.DeleteBlogRequest.
 * Use `create(DeleteBlogRequestSchema)` to create a new message.
 */
export const DeleteBlogRequestSchema: GenMessage<DeleteBlogRequest, {jsonType: DeleteBlogRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_blog, 5);

/**
 * @generated from message guardianai.v1.admin.Lead
 */
export type Lead = Message<"guardianai.v1.admin.Lead"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string email = 2;
   */
  email: string;

  /**
   * @generated from field: optional string name = 3;
   */
  name?: string;

  /**
   * @generated from field: string source = 4;
   */
  source: string;

  /**
   * @generated from field: string status = 5;
   */
  status: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 6;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 7;
   */
  updatedAt?: Timestamp;
};

/**
 * @generated from message guardianai.v1.admin.Lead
 */
export type LeadJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;

  /**
   * @generated from field: string email = 2;
   */
  email?: string;

  /**
   * @generated from field: optional string name = 3;
   */
  name?: string;

  /**
   * @generated from field: string source = 4;
   */
  source?: string;

  /**
   * @generated from field: string status = 5;
   */
  status?: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 6;
   */
  createdAt?: TimestampJson;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 7;
   */
  updatedAt?: TimestampJson;
};

/**
 * Describes the message guardianai.v1.admin.Lead.
 * Use `create(LeadSchema)` to create a new message.
 */
export const LeadSchema: GenMessage<Lead, {jsonType: LeadJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_blog, 6);

/**
 * @generated from message guardianai.v1.admin.ListLeadsRequest
 */
export type ListLeadsRequest = Message<"guardianai.v1.admin.ListLeadsRequest"> & {
  /**
   * @generated from field: int32 page = 1;
   */
  page: number;

  /**
   * @generated from field: int32 limit = 2;
   */
  limit: number;
};

/**
 * @generated from message guardianai.v1.admin.ListLeadsRequest
 */
export type ListLeadsRequestJson = {
  /**
   * @generated from field: int32 page = 1;
   */
  page?: number;

  /**
   * @generated from field: int32 limit = 2;
   */
  limit?: number;
};

/**
 * Describes the message guardianai.v1.admin.ListLeadsRequest.
 * Use `create(ListLeadsRequestSchema)` to create a new message.
 */
export const ListLeadsRequestSchema: GenMessage<ListLeadsRequest, {jsonType: ListLeadsRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_blog, 7);

/**
 * @generated from message guardianai.v1.admin.ListLeadsResponse
 */
export type ListLeadsResponse = Message<"guardianai.v1.admin.ListLeadsResponse"> & {
  /**
   * @generated from field: repeated guardianai.v1.admin.Lead leads = 1;
   */
  leads: Lead[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount: number;
};

/**
 * @generated from message guardianai.v1.admin.ListLeadsResponse
 */
export type ListLeadsResponseJson = {
  /**
   * @generated from field: repeated guardianai.v1.admin.Lead leads = 1;
   */
  leads?: LeadJson[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount?: number;
};

/**
 * Describes the message guardianai.v1.admin.ListLeadsResponse.
 * Use `create(ListLeadsResponseSchema)` to create a new message.
 */
export const ListLeadsResponseSchema: GenMessage<ListLeadsResponse, {jsonType: ListLeadsResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_blog, 8);

/**
 * @generated from message guardianai.v1.admin.BlogAnalytics
 */
export type BlogAnalytics = Message<"guardianai.v1.admin.BlogAnalytics"> & {
  /**
   * @generated from field: string blog_id = 1;
   */
  blogId: string;

  /**
   * @generated from field: int32 total_visits = 2;
   */
  totalVisits: number;

  /**
   * @generated from field: map<string, int32> countries = 3;
   */
  countries: { [key: string]: number };

  /**
   * @generated from field: map<string, int32> cities = 4;
   */
  cities: { [key: string]: number };

  /**
   * @generated from field: map<string, int32> devices = 5;
   */
  devices: { [key: string]: number };
};

/**
 * @generated from message guardianai.v1.admin.BlogAnalytics
 */
export type BlogAnalyticsJson = {
  /**
   * @generated from field: string blog_id = 1;
   */
  blogId?: string;

  /**
   * @generated from field: int32 total_visits = 2;
   */
  totalVisits?: number;

  /**
   * @generated from field: map<string, int32> countries = 3;
   */
  countries?: { [key: string]: number };

  /**
   * @generated from field: map<string, int32> cities = 4;
   */
  cities?: { [key: string]: number };

  /**
   * @generated from field: map<string, int32> devices = 5;
   */
  devices?: { [key: string]: number };
};

/**
 * Describes the message guardianai.v1.admin.BlogAnalytics.
 * Use `create(BlogAnalyticsSchema)` to create a new message.
 */
export const BlogAnalyticsSchema: GenMessage<BlogAnalytics, {jsonType: BlogAnalyticsJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_blog, 9);

/**
 * @generated from message guardianai.v1.admin.GetBlogAnalyticsRequest
 */
export type GetBlogAnalyticsRequest = Message<"guardianai.v1.admin.GetBlogAnalyticsRequest"> & {
  /**
   * @generated from field: string blog_id = 1;
   */
  blogId: string;
};

/**
 * @generated from message guardianai.v1.admin.GetBlogAnalyticsRequest
 */
export type GetBlogAnalyticsRequestJson = {
  /**
   * @generated from field: string blog_id = 1;
   */
  blogId?: string;
};

/**
 * Describes the message guardianai.v1.admin.GetBlogAnalyticsRequest.
 * Use `create(GetBlogAnalyticsRequestSchema)` to create a new message.
 */
export const GetBlogAnalyticsRequestSchema: GenMessage<GetBlogAnalyticsRequest, {jsonType: GetBlogAnalyticsRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_blog, 10);

/**
 * @generated from message guardianai.v1.admin.CompanyAbout
 */
export type CompanyAbout = Message<"guardianai.v1.admin.CompanyAbout"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * @generated from field: optional string subtitle = 3;
   */
  subtitle?: string;

  /**
   * @generated from field: string body = 4;
   */
  body: string;

  /**
   * @generated from field: optional string hero_image_url = 5;
   */
  heroImageUrl?: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 6;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 7;
   */
  updatedAt?: Timestamp;

  /**
   * @generated from field: optional string website_url = 8;
   */
  websiteUrl?: string;

  /**
   * @generated from field: optional string linkedin_url = 9;
   */
  linkedinUrl?: string;

  /**
   * @generated from field: optional string x_url = 10;
   */
  xUrl?: string;

  /**
   * @generated from field: optional string github_url = 11;
   */
  githubUrl?: string;

  /**
   * @generated from field: optional string google_business_url = 12;
   */
  googleBusinessUrl?: string;

  /**
   * @generated from field: optional string google_maps_url = 13;
   */
  googleMapsUrl?: string;

  /**
   * @generated from field: optional string yelp_url = 14;
   */
  yelpUrl?: string;
};

/**
 * @generated from message guardianai.v1.admin.CompanyAbout
 */
export type CompanyAboutJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;

  /**
   * @generated from field: string title = 2;
   */
  title?: string;

  /**
   * @generated from field: optional string subtitle = 3;
   */
  subtitle?: string;

  /**
   * @generated from field: string body = 4;
   */
  body?: string;

  /**
   * @generated from field: optional string hero_image_url = 5;
   */
  heroImageUrl?: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 6;
   */
  createdAt?: TimestampJson;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 7;
   */
  updatedAt?: TimestampJson;

  /**
   * @generated from field: optional string website_url = 8;
   */
  websiteUrl?: string;

  /**
   * @generated from field: optional string linkedin_url = 9;
   */
  linkedinUrl?: string;

  /**
   * @generated from field: optional string x_url = 10;
   */
  xUrl?: string;

  /**
   * @generated from field: optional string github_url = 11;
   */
  githubUrl?: string;

  /**
   * @generated from field: optional string google_business_url = 12;
   */
  googleBusinessUrl?: string;

  /**
   * @generated from field: optional string google_maps_url = 13;
   */
  googleMapsUrl?: string;

  /**
   * @generated from field: optional string yelp_url = 14;
   */
  yelpUrl?: string;
};

/**
 * Describes the message guardianai.v1.admin.CompanyAbout.
 * Use `create(CompanyAboutSchema)` to create a new message.
 */
export const CompanyAboutSchema: GenMessage<CompanyAbout, {jsonType: CompanyAboutJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_blog, 11);

/**
 * @generated from message guardianai.v1.admin.UpsertCompanyAboutRequest
 */
export type UpsertCompanyAboutRequest = Message<"guardianai.v1.admin.UpsertCompanyAboutRequest"> & {
  /**
   * @generated from field: string title = 1;
   */
  title: string;

  /**
   * @generated from field: optional string subtitle = 2;
   */
  subtitle?: string;

  /**
   * @generated from field: string body = 3;
   */
  body: string;

  /**
   * @generated from field: optional string hero_image_url = 4;
   */
  heroImageUrl?: string;

  /**
   * @generated from field: optional string website_url = 5;
   */
  websiteUrl?: string;

  /**
   * @generated from field: optional string linkedin_url = 6;
   */
  linkedinUrl?: string;

  /**
   * @generated from field: optional string x_url = 7;
   */
  xUrl?: string;

  /**
   * @generated from field: optional string github_url = 8;
   */
  githubUrl?: string;

  /**
   * @generated from field: optional string google_business_url = 9;
   */
  googleBusinessUrl?: string;

  /**
   * @generated from field: optional string google_maps_url = 10;
   */
  googleMapsUrl?: string;

  /**
   * @generated from field: optional string yelp_url = 11;
   */
  yelpUrl?: string;
};

/**
 * @generated from message guardianai.v1.admin.UpsertCompanyAboutRequest
 */
export type UpsertCompanyAboutRequestJson = {
  /**
   * @generated from field: string title = 1;
   */
  title?: string;

  /**
   * @generated from field: optional string subtitle = 2;
   */
  subtitle?: string;

  /**
   * @generated from field: string body = 3;
   */
  body?: string;

  /**
   * @generated from field: optional string hero_image_url = 4;
   */
  heroImageUrl?: string;

  /**
   * @generated from field: optional string website_url = 5;
   */
  websiteUrl?: string;

  /**
   * @generated from field: optional string linkedin_url = 6;
   */
  linkedinUrl?: string;

  /**
   * @generated from field: optional string x_url = 7;
   */
  xUrl?: string;

  /**
   * @generated from field: optional string github_url = 8;
   */
  githubUrl?: string;

  /**
   * @generated from field: optional string google_business_url = 9;
   */
  googleBusinessUrl?: string;

  /**
   * @generated from field: optional string google_maps_url = 10;
   */
  googleMapsUrl?: string;

  /**
   * @generated from field: optional string yelp_url = 11;
   */
  yelpUrl?: string;
};

/**
 * Describes the message guardianai.v1.admin.UpsertCompanyAboutRequest.
 * Use `create(UpsertCompanyAboutRequestSchema)` to create a new message.
 */
export const UpsertCompanyAboutRequestSchema: GenMessage<UpsertCompanyAboutRequest, {jsonType: UpsertCompanyAboutRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_blog, 12);

/**
 * @generated from message guardianai.v1.admin.TeamMember
 */
export type TeamMember = Message<"guardianai.v1.admin.TeamMember"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string full_name = 2;
   */
  fullName: string;

  /**
   * @generated from field: string role_title = 3;
   */
  roleTitle: string;

  /**
   * @generated from field: string bio = 4;
   */
  bio: string;

  /**
   * @generated from field: optional string photo_url = 5;
   */
  photoUrl?: string;

  /**
   * @generated from field: int32 display_order = 6;
   */
  displayOrder: number;

  /**
   * @generated from field: bool is_active = 7;
   */
  isActive: boolean;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 8;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 9;
   */
  updatedAt?: Timestamp;

  /**
   * @generated from field: optional string website_url = 10;
   */
  websiteUrl?: string;

  /**
   * @generated from field: optional string linkedin_url = 11;
   */
  linkedinUrl?: string;

  /**
   * @generated from field: optional string x_url = 12;
   */
  xUrl?: string;

  /**
   * @generated from field: optional string github_url = 13;
   */
  githubUrl?: string;
};

/**
 * @generated from message guardianai.v1.admin.TeamMember
 */
export type TeamMemberJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;

  /**
   * @generated from field: string full_name = 2;
   */
  fullName?: string;

  /**
   * @generated from field: string role_title = 3;
   */
  roleTitle?: string;

  /**
   * @generated from field: string bio = 4;
   */
  bio?: string;

  /**
   * @generated from field: optional string photo_url = 5;
   */
  photoUrl?: string;

  /**
   * @generated from field: int32 display_order = 6;
   */
  displayOrder?: number;

  /**
   * @generated from field: bool is_active = 7;
   */
  isActive?: boolean;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 8;
   */
  createdAt?: TimestampJson;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 9;
   */
  updatedAt?: TimestampJson;

  /**
   * @generated from field: optional string website_url = 10;
   */
  websiteUrl?: string;

  /**
   * @generated from field: optional string linkedin_url = 11;
   */
  linkedinUrl?: string;

  /**
   * @generated from field: optional string x_url = 12;
   */
  xUrl?: string;

  /**
   * @generated from field: optional string github_url = 13;
   */
  githubUrl?: string;
};

/**
 * Describes the message guardianai.v1.admin.TeamMember.
 * Use `create(TeamMemberSchema)` to create a new message.
 */
export const TeamMemberSchema: GenMessage<TeamMember, {jsonType: TeamMemberJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_blog, 13);

/**
 * @generated from message guardianai.v1.admin.ListTeamMembersRequest
 */
export type ListTeamMembersRequest = Message<"guardianai.v1.admin.ListTeamMembersRequest"> & {
  /**
   * @generated from field: int32 page = 1;
   */
  page: number;

  /**
   * @generated from field: int32 limit = 2;
   */
  limit: number;

  /**
   * @generated from field: bool include_inactive = 3;
   */
  includeInactive: boolean;
};

/**
 * @generated from message guardianai.v1.admin.ListTeamMembersRequest
 */
export type ListTeamMembersRequestJson = {
  /**
   * @generated from field: int32 page = 1;
   */
  page?: number;

  /**
   * @generated from field: int32 limit = 2;
   */
  limit?: number;

  /**
   * @generated from field: bool include_inactive = 3;
   */
  includeInactive?: boolean;
};

/**
 * Describes the message guardianai.v1.admin.ListTeamMembersRequest.
 * Use `create(ListTeamMembersRequestSchema)` to create a new message.
 */
export const ListTeamMembersRequestSchema: GenMessage<ListTeamMembersRequest, {jsonType: ListTeamMembersRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_blog, 14);

/**
 * @generated from message guardianai.v1.admin.ListTeamMembersResponse
 */
export type ListTeamMembersResponse = Message<"guardianai.v1.admin.ListTeamMembersResponse"> & {
  /**
   * @generated from field: repeated guardianai.v1.admin.TeamMember members = 1;
   */
  members: TeamMember[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount: number;
};

/**
 * @generated from message guardianai.v1.admin.ListTeamMembersResponse
 */
export type ListTeamMembersResponseJson = {
  /**
   * @generated from field: repeated guardianai.v1.admin.TeamMember members = 1;
   */
  members?: TeamMemberJson[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount?: number;
};

/**
 * Describes the message guardianai.v1.admin.ListTeamMembersResponse.
 * Use `create(ListTeamMembersResponseSchema)` to create a new message.
 */
export const ListTeamMembersResponseSchema: GenMessage<ListTeamMembersResponse, {jsonType: ListTeamMembersResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_blog, 15);

/**
 * @generated from message guardianai.v1.admin.CreateTeamMemberRequest
 */
export type CreateTeamMemberRequest = Message<"guardianai.v1.admin.CreateTeamMemberRequest"> & {
  /**
   * @generated from field: string full_name = 1;
   */
  fullName: string;

  /**
   * @generated from field: string role_title = 2;
   */
  roleTitle: string;

  /**
   * @generated from field: string bio = 3;
   */
  bio: string;

  /**
   * @generated from field: optional string photo_url = 4;
   */
  photoUrl?: string;

  /**
   * @generated from field: int32 display_order = 5;
   */
  displayOrder: number;

  /**
   * @generated from field: bool is_active = 6;
   */
  isActive: boolean;

  /**
   * @generated from field: optional string website_url = 7;
   */
  websiteUrl?: string;

  /**
   * @generated from field: optional string linkedin_url = 8;
   */
  linkedinUrl?: string;

  /**
   * @generated from field: optional string x_url = 9;
   */
  xUrl?: string;

  /**
   * @generated from field: optional string github_url = 10;
   */
  githubUrl?: string;
};

/**
 * @generated from message guardianai.v1.admin.CreateTeamMemberRequest
 */
export type CreateTeamMemberRequestJson = {
  /**
   * @generated from field: string full_name = 1;
   */
  fullName?: string;

  /**
   * @generated from field: string role_title = 2;
   */
  roleTitle?: string;

  /**
   * @generated from field: string bio = 3;
   */
  bio?: string;

  /**
   * @generated from field: optional string photo_url = 4;
   */
  photoUrl?: string;

  /**
   * @generated from field: int32 display_order = 5;
   */
  displayOrder?: number;

  /**
   * @generated from field: bool is_active = 6;
   */
  isActive?: boolean;

  /**
   * @generated from field: optional string website_url = 7;
   */
  websiteUrl?: string;

  /**
   * @generated from field: optional string linkedin_url = 8;
   */
  linkedinUrl?: string;

  /**
   * @generated from field: optional string x_url = 9;
   */
  xUrl?: string;

  /**
   * @generated from field: optional string github_url = 10;
   */
  githubUrl?: string;
};

/**
 * Describes the message guardianai.v1.admin.CreateTeamMemberRequest.
 * Use `create(CreateTeamMemberRequestSchema)` to create a new message.
 */
export const CreateTeamMemberRequestSchema: GenMessage<CreateTeamMemberRequest, {jsonType: CreateTeamMemberRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_blog, 16);

/**
 * @generated from message guardianai.v1.admin.UpdateTeamMemberRequest
 */
export type UpdateTeamMemberRequest = Message<"guardianai.v1.admin.UpdateTeamMemberRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: optional string full_name = 2;
   */
  fullName?: string;

  /**
   * @generated from field: optional string role_title = 3;
   */
  roleTitle?: string;

  /**
   * @generated from field: optional string bio = 4;
   */
  bio?: string;

  /**
   * @generated from field: optional string photo_url = 5;
   */
  photoUrl?: string;

  /**
   * @generated from field: optional int32 display_order = 6;
   */
  displayOrder?: number;

  /**
   * @generated from field: optional bool is_active = 7;
   */
  isActive?: boolean;

  /**
   * @generated from field: optional string website_url = 8;
   */
  websiteUrl?: string;

  /**
   * @generated from field: optional string linkedin_url = 9;
   */
  linkedinUrl?: string;

  /**
   * @generated from field: optional string x_url = 10;
   */
  xUrl?: string;

  /**
   * @generated from field: optional string github_url = 11;
   */
  githubUrl?: string;
};

/**
 * @generated from message guardianai.v1.admin.UpdateTeamMemberRequest
 */
export type UpdateTeamMemberRequestJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;

  /**
   * @generated from field: optional string full_name = 2;
   */
  fullName?: string;

  /**
   * @generated from field: optional string role_title = 3;
   */
  roleTitle?: string;

  /**
   * @generated from field: optional string bio = 4;
   */
  bio?: string;

  /**
   * @generated from field: optional string photo_url = 5;
   */
  photoUrl?: string;

  /**
   * @generated from field: optional int32 display_order = 6;
   */
  displayOrder?: number;

  /**
   * @generated from field: optional bool is_active = 7;
   */
  isActive?: boolean;

  /**
   * @generated from field: optional string website_url = 8;
   */
  websiteUrl?: string;

  /**
   * @generated from field: optional string linkedin_url = 9;
   */
  linkedinUrl?: string;

  /**
   * @generated from field: optional string x_url = 10;
   */
  xUrl?: string;

  /**
   * @generated from field: optional string github_url = 11;
   */
  githubUrl?: string;
};

/**
 * Describes the message guardianai.v1.admin.UpdateTeamMemberRequest.
 * Use `create(UpdateTeamMemberRequestSchema)` to create a new message.
 */
export const UpdateTeamMemberRequestSchema: GenMessage<UpdateTeamMemberRequest, {jsonType: UpdateTeamMemberRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_blog, 17);

/**
 * @generated from message guardianai.v1.admin.DeleteTeamMemberRequest
 */
export type DeleteTeamMemberRequest = Message<"guardianai.v1.admin.DeleteTeamMemberRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * @generated from message guardianai.v1.admin.DeleteTeamMemberRequest
 */
export type DeleteTeamMemberRequestJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;
};

/**
 * Describes the message guardianai.v1.admin.DeleteTeamMemberRequest.
 * Use `create(DeleteTeamMemberRequestSchema)` to create a new message.
 */
export const DeleteTeamMemberRequestSchema: GenMessage<DeleteTeamMemberRequest, {jsonType: DeleteTeamMemberRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_blog, 18);

/**
 * @generated from message guardianai.v1.admin.WorkInPublicConfig
 */
export type WorkInPublicConfig = Message<"guardianai.v1.admin.WorkInPublicConfig"> & {
  /**
   * @generated from field: string youtube_url = 1;
   */
  youtubeUrl: string;

  /**
   * live | scheduled | vod
   *
   * @generated from field: string session_status = 2;
   */
  sessionStatus: string;

  /**
   * @generated from field: string focus_area = 3;
   */
  focusArea: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp scheduled_for = 4;
   */
  scheduledFor?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 5;
   */
  updatedAt?: Timestamp;
};

/**
 * @generated from message guardianai.v1.admin.WorkInPublicConfig
 */
export type WorkInPublicConfigJson = {
  /**
   * @generated from field: string youtube_url = 1;
   */
  youtubeUrl?: string;

  /**
   * live | scheduled | vod
   *
   * @generated from field: string session_status = 2;
   */
  sessionStatus?: string;

  /**
   * @generated from field: string focus_area = 3;
   */
  focusArea?: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp scheduled_for = 4;
   */
  scheduledFor?: TimestampJson;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 5;
   */
  updatedAt?: TimestampJson;
};

/**
 * Describes the message guardianai.v1.admin.WorkInPublicConfig.
 * Use `create(WorkInPublicConfigSchema)` to create a new message.
 */
export const WorkInPublicConfigSchema: GenMessage<WorkInPublicConfig, {jsonType: WorkInPublicConfigJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_blog, 19);

/**
 * @generated from message guardianai.v1.admin.UpdateWorkInPublicConfigRequest
 */
export type UpdateWorkInPublicConfigRequest = Message<"guardianai.v1.admin.UpdateWorkInPublicConfigRequest"> & {
  /**
   * @generated from field: string youtube_url = 1;
   */
  youtubeUrl: string;

  /**
   * live | scheduled | vod
   *
   * @generated from field: string session_status = 2;
   */
  sessionStatus: string;

  /**
   * @generated from field: string focus_area = 3;
   */
  focusArea: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp scheduled_for = 4;
   */
  scheduledFor?: Timestamp;
};

/**
 * @generated from message guardianai.v1.admin.UpdateWorkInPublicConfigRequest
 */
export type UpdateWorkInPublicConfigRequestJson = {
  /**
   * @generated from field: string youtube_url = 1;
   */
  youtubeUrl?: string;

  /**
   * live | scheduled | vod
   *
   * @generated from field: string session_status = 2;
   */
  sessionStatus?: string;

  /**
   * @generated from field: string focus_area = 3;
   */
  focusArea?: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp scheduled_for = 4;
   */
  scheduledFor?: TimestampJson;
};

/**
 * Describes the message guardianai.v1.admin.UpdateWorkInPublicConfigRequest.
 * Use `create(UpdateWorkInPublicConfigRequestSchema)` to create a new message.
 */
export const UpdateWorkInPublicConfigRequestSchema: GenMessage<UpdateWorkInPublicConfigRequest, {jsonType: UpdateWorkInPublicConfigRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_blog, 20);

/**
 * @generated from message guardianai.v1.admin.EngineConsoleGuideConfig
 */
export type EngineConsoleGuideConfig = Message<"guardianai.v1.admin.EngineConsoleGuideConfig"> & {
  /**
   * @generated from field: string distro_engine_console_youtube_url = 1;
   */
  distroEngineConsoleYoutubeUrl: string;

  /**
   * @generated from field: string caption_engine_console_youtube_url = 2;
   */
  captionEngineConsoleYoutubeUrl: string;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 3;
   */
  updatedAt?: Timestamp;
};

/**
 * @generated from message guardianai.v1.admin.EngineConsoleGuideConfig
 */
export type EngineConsoleGuideConfigJson = {
  /**
   * @generated from field: string distro_engine_console_youtube_url = 1;
   */
  distroEngineConsoleYoutubeUrl?: string;

  /**
   * @generated from field: string caption_engine_console_youtube_url = 2;
   */
  captionEngineConsoleYoutubeUrl?: string;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 3;
   */
  updatedAt?: TimestampJson;
};

/**
 * Describes the message guardianai.v1.admin.EngineConsoleGuideConfig.
 * Use `create(EngineConsoleGuideConfigSchema)` to create a new message.
 */
export const EngineConsoleGuideConfigSchema: GenMessage<EngineConsoleGuideConfig, {jsonType: EngineConsoleGuideConfigJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_blog, 21);

/**
 * @generated from message guardianai.v1.admin.UpdateEngineConsoleGuideConfigRequest
 */
export type UpdateEngineConsoleGuideConfigRequest = Message<"guardianai.v1.admin.UpdateEngineConsoleGuideConfigRequest"> & {
  /**
   * @generated from field: string distro_engine_console_youtube_url = 1;
   */
  distroEngineConsoleYoutubeUrl: string;

  /**
   * @generated from field: string caption_engine_console_youtube_url = 2;
   */
  captionEngineConsoleYoutubeUrl: string;
};

/**
 * @generated from message guardianai.v1.admin.UpdateEngineConsoleGuideConfigRequest
 */
export type UpdateEngineConsoleGuideConfigRequestJson = {
  /**
   * @generated from field: string distro_engine_console_youtube_url = 1;
   */
  distroEngineConsoleYoutubeUrl?: string;

  /**
   * @generated from field: string caption_engine_console_youtube_url = 2;
   */
  captionEngineConsoleYoutubeUrl?: string;
};

/**
 * Describes the message guardianai.v1.admin.UpdateEngineConsoleGuideConfigRequest.
 * Use `create(UpdateEngineConsoleGuideConfigRequestSchema)` to create a new message.
 */
export const UpdateEngineConsoleGuideConfigRequestSchema: GenMessage<UpdateEngineConsoleGuideConfigRequest, {jsonType: UpdateEngineConsoleGuideConfigRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_blog, 22);

/**
 * @generated from service guardianai.v1.admin.AdminMarketingService
 */
export const AdminMarketingService: GenService<{
  /**
   * @generated from rpc guardianai.v1.admin.AdminMarketingService.ListBlogs
   */
  listBlogs: {
    methodKind: "unary";
    input: typeof ListBlogsRequestSchema;
    output: typeof ListBlogsResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.admin.AdminMarketingService.CreateBlog
   */
  createBlog: {
    methodKind: "unary";
    input: typeof CreateBlogRequestSchema;
    output: typeof BlogSchema;
  },
  /**
   * @generated from rpc guardianai.v1.admin.AdminMarketingService.UpdateBlog
   */
  updateBlog: {
    methodKind: "unary";
    input: typeof UpdateBlogRequestSchema;
    output: typeof BlogSchema;
  },
  /**
   * @generated from rpc guardianai.v1.admin.AdminMarketingService.DeleteBlog
   */
  deleteBlog: {
    methodKind: "unary";
    input: typeof DeleteBlogRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc guardianai.v1.admin.AdminMarketingService.GetCompanyAbout
   */
  getCompanyAbout: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof CompanyAboutSchema;
  },
  /**
   * @generated from rpc guardianai.v1.admin.AdminMarketingService.UpsertCompanyAbout
   */
  upsertCompanyAbout: {
    methodKind: "unary";
    input: typeof UpsertCompanyAboutRequestSchema;
    output: typeof CompanyAboutSchema;
  },
  /**
   * @generated from rpc guardianai.v1.admin.AdminMarketingService.ListTeamMembers
   */
  listTeamMembers: {
    methodKind: "unary";
    input: typeof ListTeamMembersRequestSchema;
    output: typeof ListTeamMembersResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.admin.AdminMarketingService.CreateTeamMember
   */
  createTeamMember: {
    methodKind: "unary";
    input: typeof CreateTeamMemberRequestSchema;
    output: typeof TeamMemberSchema;
  },
  /**
   * @generated from rpc guardianai.v1.admin.AdminMarketingService.UpdateTeamMember
   */
  updateTeamMember: {
    methodKind: "unary";
    input: typeof UpdateTeamMemberRequestSchema;
    output: typeof TeamMemberSchema;
  },
  /**
   * @generated from rpc guardianai.v1.admin.AdminMarketingService.DeleteTeamMember
   */
  deleteTeamMember: {
    methodKind: "unary";
    input: typeof DeleteTeamMemberRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc guardianai.v1.admin.AdminMarketingService.ListLeads
   */
  listLeads: {
    methodKind: "unary";
    input: typeof ListLeadsRequestSchema;
    output: typeof ListLeadsResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.admin.AdminMarketingService.GetBlogAnalytics
   */
  getBlogAnalytics: {
    methodKind: "unary";
    input: typeof GetBlogAnalyticsRequestSchema;
    output: typeof BlogAnalyticsSchema;
  },
  /**
   * @generated from rpc guardianai.v1.admin.AdminMarketingService.GetWorkInPublicConfig
   */
  getWorkInPublicConfig: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof WorkInPublicConfigSchema;
  },
  /**
   * @generated from rpc guardianai.v1.admin.AdminMarketingService.UpdateWorkInPublicConfig
   */
  updateWorkInPublicConfig: {
    methodKind: "unary";
    input: typeof UpdateWorkInPublicConfigRequestSchema;
    output: typeof WorkInPublicConfigSchema;
  },
  /**
   * @generated from rpc guardianai.v1.admin.AdminMarketingService.GetEngineConsoleGuideConfig
   */
  getEngineConsoleGuideConfig: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof EngineConsoleGuideConfigSchema;
  },
  /**
   * @generated from rpc guardianai.v1.admin.AdminMarketingService.UpdateEngineConsoleGuideConfig
   */
  updateEngineConsoleGuideConfig: {
    methodKind: "unary";
    input: typeof UpdateEngineConsoleGuideConfigRequestSchema;
    output: typeof EngineConsoleGuideConfigSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_guardianai_v1_admin_blog, 0);

